/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Link_HelpInputs */

const en_import_link_help = /** @type {(inputs: Import_Link_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube, Instagram, TikTok, X, Facebook or any recipe page`)
};

const de_import_link_help = /** @type {(inputs: Import_Link_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube, Instagram, TikTok, X, Facebook oder jede Rezeptseite`)
};

/**
* | output |
* | --- |
* | "YouTube, Instagram, TikTok, X, Facebook or any recipe page" |
*
* @param {Import_Link_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_link_help = /** @type {((inputs?: Import_Link_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Link_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_link_help(inputs)
	return en_import_link_help(inputs)
});